<template>
  <div id="transfer-history" class="table-responsive">
    <table class="table table-sm table-striped table-hover table-bordered">
      <thead>
        <tr>
          <th scope="col">Transferred From</th>
          <th scope="col">Transfer Date</th>
          <th scope="col">Reference Number</th>
          <th scope="col">Document Number</th>
          <th scope="col">Book</th>
          <th scope="col">Page</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="!items.length">
          <td colspan="6" class="text-center text-muted p-3">
            No data
          </td>
        </tr>
        <tr v-for="(item, index) in items" v-bind:key="index">
          <td>{{ item.FROMOWNEROFRECORD }}</td>
          <td>
            {{ item.TRANSFERDATE | toDate }}
          </td>
          <td>{{ item.TRANSFERREFERENCENBR }}</td>
          <td>{{ item.RECORDERSDOCNBR }}</td>
          <td>{{ item.RECORDERSBOOK }}</td>
          <td>{{ item.RECORDERSPAGE }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
};
</script>
